import React, { Component } from 'react';
import './Nav.css';

class Nav extends Component {
  render() {
    return (
      <div className="navbar">
        <div className="navbar-title">
          <a href="/">
            <span className="navbar-title-brand">Hayward Place</span>
          </a>
        </div>
        <div className="sub-nav">
          <a href="/#neighborhood">
            <span>Neighborhood</span>
          </a>
          <a href="/#history">
            <span>History</span>
          </a>
          <a href="/#contact">
            <span>Contact</span>
          </a>
          <a href="/listings">
            <span>Listings</span>
          </a>
        </div>
      </div>
    );
  }
}

export default Nav;



// WEBPACK FOOTER //
// ./src/Nav.jsx